var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavDown = function SvgNavDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.97,
    height: 16.97,
    viewBox: "0 0 16.97 16.97"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1a1b1f",
    d: "M7.778 16.263.707 9.193A1 1 0 1 1 2.12 7.777l6.364 6.364 6.364-6.364a1 1 0 1 1 1.414 1.414l-7.07 7.071a1 1 0 0 1-1.415 0",
    "data-name": "Union 18",
    opacity: 0.3
  })));
};
export default SvgNavDown;